export const COLUMNS = [
  {
    Header: "Accounting Software",
    Footer: "Accounting Software",
    accessor: "name"
  },
  {
    Header: "Logo",
    Footer: "Logo",
    accessor: "iconUrl"
  },
  {
    Header: "Total Users",
    Footer: "Total Users",
    accessor: "totalUsers"
  },
  {
    Header: "Active",
    Footer: "Active",
    accessor: "isSupported"
  }
];
